import axios from "axios";
import Notifications from 'react-notification-system-redux';
import {change, untouch} from 'redux-form';
import { ROOT_URL, POSTING, COMPLETED } from "./types";

export function sendTransactionsToClient(email, message) {
  console.log('function clicked - sendTransactionsToClient');
  const bookId = localStorage.getItem('bookid');

  return function (dispatch) {
    dispatch({ type: POSTING });
    axios.post(`${ROOT_URL}/books/${bookId}/sharetransactions`, { email, message },
      { headers: { authorizationtoken: localStorage.getItem("token"), cognitotoken: localStorage.getItem("cognitotoken"), authtype: localStorage.getItem("authtype") } })
      .then(response => {
        dispatch({ type: COMPLETED, payload: true });
        dispatch(Notifications.success({ message: 'Email Sent' }));
      })
      .catch(() => {
        dispatch({ type: COMPLETED, payload: false });
        dispatch(Notifications.warning({ message: 'Unable to send transactions' }));
      });
  };
}


// WEBPACK FOOTER //
// ./src/Actions/sendToClient.js